<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0 write-a-review">
	<div class="title" *ngIf="!showRatingInCentre">Write a Review</div>
	<div class="title-center" *ngIf="showRatingInCentre">Write a Review</div>
	<div>
		<form [formGroup]=form (autocomplete)="'false'" (submit)="onSubmit(form)">
			<div class="form-group" *ngIf="!showRatingInCentre">
				<p>Score</p>
				<p [style.display]="'flex'">
					<star-rating class="pull-left" [starType]="'svg'"
						(ratingChange)="form.controls.rating.setValue($event.rating)" [rating]="form.value.rating"
						[staticColor]="'ok'"></star-rating>
				</p>
				<p class="error"
					*ngIf="form.get('rating')?.invalid && (form.get('rating')?.dirty || form.get('rating')?.touched)">
					Please enter valid rating
				</p>
			</div>
			<div class="form-group" *ngIf="showRatingInCentre">
				<p>Score</p>
				<p>
					<star-rating class="start-rating" [starType]="'svg'"
						(ratingChange)="form.controls.rating.setValue($event.rating)" [rating]="form.value.rating"
						[staticColor]="'ok'"></star-rating>
				</p>
				<p class="error"
					*ngIf="form.get('rating')?.invalid && (form.get('rating')?.dirty || form.get('rating')?.touched)">
					Please enter valid rating
				</p>
			</div>
			<div class="form-group">
				<p>Review</p>
				<app-text-area class="border" [placeholder]="'Write your comment here...'"
					(onChangeEvent)="form.controls.comments.setValue($event);markTouchedAndDirty($event, 'comments', form)"></app-text-area>
				<p class="error"
					*ngIf="form.get('comments')?.invalid && (form.get('comments')?.dirty || form.get('comments')?.touched)">
					Please enter valid comments
				</p>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
				<button mat-button class="btn btn-review-post">POST</button>
			</div>
		</form>
	</div>
</div>